import React from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import moment from "moment";
import {
  formattedAmountWithoutAed,
} from "../../../../../../utils/CommonFunction";
import { ReactComponent as SmallDhiramIcon } from "../../../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../../../utils/CurrencyUtils";
import { ReactComponent as DhiramIcon } from "../../../../../../assets/svg/DhiramIcon.svg";


const Container = styled(Box)`
  display: flex;
  gap: 16px;
  font-weight: 500;
`;

const Column = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled(Box)`
  display: flex;
  gap: 8px;
  font-size: 0.875rem; /* equivalent to text-sm */
`;

const MetaDetails = ({ data,projectDetails }) => {
  const milestoneName =
    data?.newMilestoneDetails?.proposalMilestone?.milestoneName;
  const newMoveInDate = projectDetails?.end_date;

  const price = data?.changeRequest?.changeRequestPrice;
  const cost = data?.changeRequest?.changeRequestCost;

  const startDate = data?.newMilestoneDetails?.proposalMilestone?.startDate;
  const endDate = data?.newMilestoneDetails?.proposalMilestone?.endDate;

  return (
    <Container>
      <Column sx={{ width: "66.66%" }}>
        <Row>
          <Typography fontSize={14} fontWeight={500} color="text.secondary">
            Milestone Name:
          </Typography>
          <Typography fontSize={14} fontWeight={500}>
            {milestoneName || "-"}
          </Typography>
        </Row>

        <Row>
          <Typography fontSize={14} fontWeight={500} color="text.secondary">
            Start Date:
          </Typography>
          <Typography fontSize={14} fontWeight={500}>
            {startDate ? moment(startDate).format("MMM DD, yyyy") : "-"}
          </Typography>
        </Row>
        <Row>
          <Typography fontSize={14} fontWeight={500} color="text.secondary">
            Move-In Date:
          </Typography>
          <Typography fontSize={14} fontWeight={500}>
            {newMoveInDate ? newMoveInDate : "-"}
          </Typography>
        </Row>
      </Column>

      <Column sx={{ width: "33.33%" }}>
        <Row>
          <Typography fontSize={14} fontWeight={500} color="text.secondary">
            Cost:
          </Typography>
          <Typography fontSize={14} fontWeight={500}>
            <DhiramIcon height={12} />
            {formattedAmountWithoutAed(cost)}
          </Typography>
        </Row>
        <Row>
          <Typography fontSize={14} fontWeight={500} color="text.secondary">
            End Date:
          </Typography>
          <Typography fontSize={14} fontWeight={500}>
            {endDate ? moment(endDate).format("MMM DD, yyyy") : "-"}
          </Typography>
        </Row>
      </Column>
    </Container>
  );
};

export default MetaDetails;
